import { SocketClient } from './SocketClient'
import { EAuthSocketEvents } from '@devglobalbot/global-contracts'
import moment from 'moment'

export class AuthSocket extends SocketClient {
  constructor(store: any) {
    super({
      url: process.env.VUE_APP_SOCKET_AUTH!,
      namespace: 'auth',
      auth: {},
    })

    this.registerEvents(store)
  }

  private registerEvents(store: any) {
    this.on(EAuthSocketEvents.alarm, (payload: any) => {
      try {
        const defaultDate = new Date(payload.controller.end)
        defaultDate.setMinutes(defaultDate.getMinutes() + payload.tolerance)

        const toleranceDate = moment.utc(defaultDate.getTime() - Date.now())

        store.commit('main/setToleranceAlarm', toleranceDate)

        const counter = setInterval(() => {
          toleranceDate.subtract(1, 's')
          store.commit('main/setToleranceAlarm', toleranceDate)
          store.commit('main/setDisplayAlarm', toleranceDate.format('HH:mm:ss'))

          if (toleranceDate.format('HH:mm:ss') === '00:00:00') {
            clearInterval(counter)
          }
        }, 1000)

        store.commit('main/enableAlarm')
      } catch (e) {
        console.error(e)
      }
    })
  }
}
